import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getEmails: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails`,
        params: {
            '$count': true,
        }
    },
    getEmailsPaged: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/emailsPaged`
    },
    getSenders: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/senders`
    },

    getEmail: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/:id`
    },

    getEmailAttachments: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/emailContent/attachments/:logId`
    },

    getEmailContent: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/emailContent/:logId/:recordId`
    },

    getEmailTemplate: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/emailContent/:logId`
    },

    getPendingEmails: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/groupEmails/pendingEmails`
    },

    getTerminalCardDates: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/activity/terminalCardDates`
    },

    getActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/resident/:userLeaseId`
    },

    getActivityTimelineSenders: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/activity/senders`
    },

    getLeaseActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/lease/:leaseId`
    },

    getRentalOwnerActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/rentalOwner/:userId`
    },

    getVendorActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/vendor/:vendorId`
    },

    getApplicantActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/applicant/:userId`
    },

    createPhoneCallLog: {
        method: 'POST',
        url: `${BASE_PATH_API}/phoneCallLog`
    },
    deletePhoneCallLog: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/phoneCallLog/:logId`
    },
    updatePhoneCallLog: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/phoneCallLog/:PhoneCallLogId`
    },

    getProspectActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/communications/prospect/:userId`
    },
};

export function CommunicationsApi() {
    return createActions(actions);
}
